module.exports = __webpack_public_path__ + "img/schedule-plug-icon.20cd8fa6.svg";